import { useContext } from 'react'
import { WorkspaceContext } from '../context/WorkspaceContext'

export default () => {
  return useContext(WorkspaceContext)
}
